(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-navigation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.kolNavInit) return;
    window.kolNavInit = true;

    async function load(url, push) {
      const main = document.querySelector('main');
      const oldSubs = document.querySelector('.kol-nav__subs');
      const scroll = oldSubs ? oldSubs.scrollLeft : 0;
      document.documentElement.classList.add('kol-nav-loading');
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const newMain = doc.querySelector('main');
        if (!main || !newMain) throw new Error('Intet hovedindhold fundet');

        main.replaceChildren(...Array.from(newMain.childNodes, (n) => document.importNode(n, true)));
        document.title = doc.title;
        if (push) history.pushState({ kolNav: true }, '', url);

        const newSubs = document.querySelector('.kol-nav__subs');
        if (newSubs) newSubs.scrollLeft = scroll;
      } catch (err) {
        window.location.href = url;
      } finally {
        document.documentElement.classList.remove('kol-nav-loading');
      }
    }

    document.addEventListener('click', (e) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const a = e.target.closest('.kol-nav[data-ajax] a[data-kol-link]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (a.href !== location.href) load(a.href, true);
    });

    if (document.querySelector('.kol-nav[data-ajax]')) {
      history.replaceState({ ...history.state, kolNav: true }, '');
    }
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.kolNav) load(location.href, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
